import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './OrderBreakdown.module.css';

const LineItemVatInfo = props => {
  const { lineItems } = props;
  const vatRate = 25.5;

  const vatableLineItems = lineItems.filter(
    item =>
      !item.reversal &&
      item.lineTotal &&
      !item.code.includes('shipping') &&
      !item.code.includes('pickup')
  );

  if (vatableLineItems.length === 0) {
    return null;
  }

  const totalAmountInCents = vatableLineItems.reduce((sum, item) => sum + item.lineTotal.amount, 0);

  const totalAmount = totalAmountInCents / 100;

  const vatAmount = (totalAmount * vatRate) / (100 + vatRate);

  const formattedVatAmount = vatAmount.toFixed(2);

  console.log('Vatable items:', vatableLineItems);
  console.log('Total amount in cents:', totalAmountInCents);
  console.log('Total amount in EUR:', totalAmount);
  console.log('VAT amount:', vatAmount);

  return (
    <span className={css.vatInfo}>
      <FormattedMessage
        id="OrderBreakdown.vatInfo"
        values={{
          vatRate: vatRate,
          vatAmount: formattedVatAmount,
        }}
      />
    </span>
  );
};

export default LineItemVatInfo;
